import { select, put } from 'redux-saga/effects'
// import { push } from 'connected-react-router'
// import GlobalActions from 'store/redux/global'
import AuthActions from 'store/redux/auth'
// import Socket from 'api'
// import Config from 'config'

export function* startup() {
    if (process.env.NODE_ENV === 'production' || true) {
        yield put(AuthActions.setNumberOfReconnectionTrials(0))
        yield put(AuthActions.tryReconnect())
    }
}



// WEBPACK FOOTER //
// src/store/sagas/system.js